import { render, staticRenderFns } from "./CCSkillSelector.vue?vue&type=template&id=2de40fd4&scoped=true&"
import script from "./CCSkillSelector.vue?vue&type=script&lang=ts&"
export * from "./CCSkillSelector.vue?vue&type=script&lang=ts&"
import style0 from "./CCSkillSelector.vue?vue&type=style&index=0&id=2de40fd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de40fd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VChip,VCol,VDivider,VRow})
